<template>
  <div class="setting-component">
    <!-- [ Menu ] end -->
    <div class="wrap">
      <div class="wrap__tree">
        <div class="nav-tree">
          <el-button @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Account</el-button>
        </div>
        <el-table
          ref="singleTable"
          highlight-current-row
          @current-change="handleCurrentChange"
          :data="tableData"
          style="width: 100%"
          row-key="id"
          default-expand-all>
          <el-table-column
            prop="code"
            label="Code">
          </el-table-column>
          <el-table-column
            prop="name"
            label="Name">
          </el-table-column>
          <el-table-column
            prop="description"
            label="Description">
          </el-table-column>
          <el-table-column
            width="150"
            label="Operations">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                plain
                icon="el-icon-edit"
                @click="openModalAdd('update', scope.$index, scope.row)"></el-button>
              <el-button
                v-if="!scope.row.children.length"
                size="mini"
                type="danger"
                plain
                icon="el-icon-delete"
                @click="handleDelete(scope.$index, scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- Add -->
    <sweet-modal blocking ref="openModal"  class="modal" v-on:close="closeModal">
      <h1>Add Account</h1>
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input placeholder="Name" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input placeholder="Code" v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item prop="description">
          <el-input placeholder="Description" v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.accountTypeId" placeholder="Account Type" style="width: 100%;">
            <el-option v-for="item in accountTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.rootTypeId" placeholder="Root Type" style="width: 100%;">
            <el-option v-for="item in rootTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="addItem('form')" class="modal__btn" type="primary" plain size="small">Add Account</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

    <!-- Edit -->
    <sweet-modal blocking ref="openModalEdit"  class="modal" v-on:close="closeModalEdit">
      <h1>Edit Account</h1>
      <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input placeholder="Name" v-model="formEdit.name"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input placeholder="Code" v-model="formEdit.code"></el-input>
        </el-form-item>
        <el-form-item prop="description">
          <el-input placeholder="Description" v-model="formEdit.description"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formEdit.accountTypeId" placeholder="Account Type" style="width: 100%;">
            <el-option v-for="item in accountTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formEdit.rootTypeId" placeholder="Root Type" style="width: 100%;">
            <el-option v-for="item in rootTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="editItem('formEdit')" class="modal__btn" type="primary" plain size="small">Edit Account</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

    <!-- Are you sure? -->
    <sweet-modal blocking ref="confirmation" :title="`Delete ` + btnText">
      Are you sure you want to delete this {{btnText}}?
      <template slot="box-action">
        <el-button class="button" @click="deleteConfirm">Delete {{btnText}}</el-button> &nbsp;
      </template>
    </sweet-modal>

  </div>
</template>

<script>
  import _ from 'lodash'
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'company-stages',
    components: {
      // Header,
      // Menu,
      SweetModal,

    },
    data() {
      return {
        btnText: 'Chart Of Account',
        tableData: [],
        selectedRowId: '',
        moment:moment,

        accountTypeList: [],
        rootTypeList: [],

        form:{
          name: '',
          code: '',
          description: '',
          accountTypeId: null,
          rootTypeId: null,
        },
        formEdit:{
          name: '',
          code: '',
          description: '',
          accountTypeId: null,
          rootTypeId: null,
        },
        rules: {
          name: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          code: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          description: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          code: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          description: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ]
        },
        modalDel:false,
        currentRow: null,

      }
    },
    methods: {
      buildTree(projectTaskList, parentCompanyChartOfAccountItemId = null) {
        var resultProjectTaskTree = [];
        for (var index = 0; index < projectTaskList.length; index++) {
          if (projectTaskList[index].parentCompanyChartOfAccountItemId == parentCompanyChartOfAccountItemId) {
            var childElementList = this.buildTree(projectTaskList, projectTaskList[index].id);

              let row = {
                children: childElementList,
                code: projectTaskList[index].code,
                companyId: projectTaskList[index].companyId,
                createDate: projectTaskList[index].createDate,
                description: projectTaskList[index].description,
                id: projectTaskList[index].id,
                name: projectTaskList[index].name,
                parentCompanyChartOfAccountItemId: projectTaskList[index].parentCompanyChartOfAccountItemId
              }
              resultProjectTaskTree.push(row);
          }
        }
        return resultProjectTaskTree;
      },
      setCurrent(row) {
        this.$refs.singleTable.setCurrentRow(row);
        console.log('---setCurrent', row);
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        console.log('---handleCurrentChange', val);
      },
      // cellClick(row, column, event){
      //   if(column.label !== 'Operations'){
      //     this.$refs.openModal.open()
      //   }
      // },
      // * companyChartOfAccountItems/list
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyChartOfAccountItems/list?companyId=${this.$route.query.companyId}`)
          .then(response => {

            // this.tableData = list
            this.tableData = this.buildTree(response.data.list)
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      openModalAdd(operation, index, row){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyChartOfAccountItems/directories?companyId=${this.$route.query.companyId}&operation=${operation}`)
          .then(response => {
            if(operation === 'create'){
              this.accountTypeList = response.data.accountTypeList
              this.rootTypeList = response.data.rootTypeList
              this.$refs.openModal.open()
            }else if(operation === 'update'){
              this.accountTypeList = response.data.accountTypeList
              this.rootTypeList = response.data.rootTypeList
              this.handleEdit(index, row)
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });

        // if(operation === 'create'){
        //   this.$refs.openModal.open()
        // }else if(operation === 'update'){
        //   this.handleEdit(index, row)
        // }
      },
      // * companyChartOfAccountItems/create
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              name: this.form.name,
              code: this.form.code,
              description: this.form.description,
              parentCompanyChartOfAccountItemId: null,
              rootType: this.form.rootTypeId,
              accountType: this.form.accountTypeId,
            }

            if (this.currentRow !== null) {
              data.parentCompanyChartOfAccountItemId = this.currentRow.id
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companyChartOfAccountItems/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.notification("Success", `Add ${this.btnText}`, "success");
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      closeModal(){
        this.form.name = ''
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.name = ''
        this.$refs['formEdit'].resetFields();
      },
      // * companyChartOfAccountItems/item
      handleEdit(index, row) {
        this.selectedRowId = row.id
        let loader = this.$loading.show();
        let Id = 'companyStageId'
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyChartOfAccountItems/item?companyId=${this.$route.query.companyId}&companyChartOfAccountItemId=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.name = response.data.item.name
            this.formEdit.code = response.data.item.code
            this.formEdit.description = response.data.item.description
            this.formEdit.rootTypeId = response.data.item.rootType
            this.formEdit.accountTypeId = response.data.item.accountType
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      // * companyChartOfAccountItems/update
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let data = {
              name: this.formEdit.name,
              code: this.formEdit.code,
              description: this.formEdit.description,
              rootType: this.formEdit.rootTypeId,
              accountType: this.formEdit.accountTypeId,
            }
            let loader = this.$loading.show();
            let Id = 'companyStageId'
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companyChartOfAccountItems/update?companyId=${this.$route.query.companyId}&companyChartOfAccountItemId=${this.selectedRowId}`, data)
              .then(response => {
                this.notification("Success", `Edit ${this.btnText}`, "success");
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        console.log(row.id)
        // this.$refs.confirmation.open()
        this.selectedRowId = row.id
        console.log(row)

        this.$confirm('This will permanently delete the chart of account. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyChartOfAccountItems/delete?companyId=${this.$route.query.companyId}&companyChartOfAccountItemId=${this.selectedRowId}`)
            .then(response => {
              this.$refs.confirmation.close()
              this.loadList()
              this.notification("Success", `Delete ${this.btnText}`, "success");
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      // * companyChartOfAccountItems/delete
      deleteConfirm(){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyChartOfAccountItems/delete?companyId=${this.$route.query.companyId}&companyChartOfAccountItemId=${this.selectedRowId}`)
          .then(response => {
            this.$refs.confirmation.close()
            this.loadList()
            this.notification("Success", `Delete ${this.btnText}`, "success");
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      // showMenu() {
      //   this.open = true
      //   console.log('---', this.open);
      // },
      // hideMenu() {
      //   this.open = false
      //   console.log('---', this.open);
      // },
      // companyName(name) {
      //   this.companyNameSelect = name
      // },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
    .setting-component{
        min-width:810px;
    }
    .sweet-modal-overlay{
        z-index:10;
    }
    /deep/.el-notification .right{
        z-index: 9999999;
    }
</style>
